import { REWRITE_TIERS } from '@lyrmo/shared';
import { formatShortcut } from '@lyrmo/shared/shortcuts';
import type { CSSProperties } from 'react';
import { Icon } from '../../components/Icon';
import { useI18n } from '../../i18n/i18n-context';
import { cx } from '../../lib/cx';
import { useShortcuts } from '../shortcuts/useShortcuts';

/** Previews the four versions a rewrite produces, each with its copy shortcut. */
export function EmptyState() {
  const { t } = useI18n();
  const { platform, shortcuts } = useShortcuts();

  return (
    <div className="empty-state">
      <span className="empty-icon" aria-hidden="true">
        <Icon name="sparkle" />
      </span>
      <h3 className="empty-title">{t.empty.title}</h3>
      <p className="empty-description">{t.empty.description}</p>
      <ol className="tier-preview" aria-label={t.empty.preview}>
        {REWRITE_TIERS.map((tier, index) => (
          // Each row, and each step of its meter, arrives a beat after the one before.
          <li className="tier-preview-item" key={tier} style={{ '--item': index } as CSSProperties}>
            <span className="strength-meter" aria-hidden="true">
              {REWRITE_TIERS.map((step, stepIndex) => (
                <span
                  key={step}
                  className={cx('strength-step', stepIndex <= index && 'is-on')}
                  style={{ '--step': stepIndex } as CSSProperties}
                />
              ))}
            </span>
            <span className="tier-preview-label">{t.tiers[tier].label}</span>
            <kbd className="kbd" aria-hidden="true">
              {formatShortcut(shortcuts.useVersion, platform, String(index + 1))}
            </kbd>
          </li>
        ))}
      </ol>
    </div>
  );
}
